module.exports = __webpack_public_path__ + "static/media/enter-date.2468a133.svg";